module.exports = __webpack_public_path__ + "img/yunshanfu.27adc550.svg";